import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

/** Sticky banner when the browser reports offline (PWA / spotty connections). */
export function OnlineStatusBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true
  );

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (online) {
    return null;
  }

  return (
    <div
      className="no-print sticky top-0 z-sticky flex items-center justify-center gap-2 bg-burgundy/95 text-white text-sm px-3 py-2 text-center"
      role="status"
      aria-live="polite"
    >
      <WifiOff className="w-4 h-4 shrink-0" aria-hidden />
      <span>
        You appear to be offline. You can keep browsing; saving or loading from the server may fail until you reconnect.
      </span>
    </div>
  );
}
